var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasTiles = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:none;stroke:currentColor;stroke-width:2.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3,6.2v19.6C3,27,3.9,28,5,28h22c1.1,0,2-1,2-2.2V6.2C29,5,28.1,4,27,4H5C3.9,4,3,5,3,6.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 0,
    x2: 11,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 25,
    x2: 11,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 21,
    y1: 25,
    x2: 21,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 10,
    x2: 11,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 21,
    y1: 10,
    x2: 21,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 18,
    x2: 11,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 21,
    y1: 18,
    x2: 21,
    y2: 22
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasTiles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas-tiles.aadbfb9bf8741fac9d86943b6437587d.svg";